import domReady from '@wordpress/dom-ready';

domReady(() => {
  const btns = document.querySelectorAll(
    '.wp-block-button.is-style-btn-arrow .wp-element-button, .wp-block-button.is-style-btn-arrow-secondary .wp-element-button,.wp-block-button.is-style-btn-inline .wp-element-button, .gform_button'
  );
  if (btns) {
    btns.forEach((btn) => {
      btn.innerHTML =
        '<span class="label">' +
        btn.innerHTML +
        '</span><span class="icon icon-arrow-right"></span>';
    });
  }
});
